// extracted by mini-css-extract-plugin
export default {"cropZoomDropdown":"ButtonCropZoom_cropZoomDropdown__MPXPE","zoomInIcon":"ButtonCropZoom_zoomInIcon__ed6Nn"};